/** Browser entry point. */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { setupI18n } from "@/i18n";
import { initTelemetry, maybeSendTestEvent } from "@/shared/lib/telemetry";

import "maplibre-gl/dist/maplibre-gl.css";
import "./styles.css";

setupI18n();
void initTelemetry().then(() => maybeSendTestEvent());

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
